import DefaultModal from "components/Common/Modal/DefaultModal";
import ModalButton from "components/Common/Modal/ModalButton";
import React from "react";

const SignupModal = ({ modalClose }: { modalClose: () => void }) => {
  return (
    <DefaultModal
      title="등록된 회원정보가 없습니다"
      content="회원가입을 진행하시겠습니까?"
      handlModalClose={modalClose}
      state="error"
      button={
        <ModalButton
          buttonType="two"
          confirmButtonText="회원가입"
          handleConfirm={() => {
            modalClose();
            window.location.href = "/signup";
          }}
          handleCancel={modalClose}
        />
      }
    />
  );
};

export default SignupModal;
